import * as angular from 'angular';
import { fn, IInfOperation } from '@common/utils';
import { InfUserSettingsAccess as _InfUserSettingsAccess } from '@common/services/settingsservice';
import { NavGridOptions, INavGrid, INavGridImp, GetGridOptionSettings, BindGridCustomizations } from '@common/navkendo/navgrid';
import * as kutils from '../navkendo';
import { constants as kconstants, IGridCustomization, GetRowItem, GetGrid, Bind } from '../navkendo';
import UISafe = fn.UISafe;
import { GetCustomKendoTemplate, TEMPLATE_ID } from '../kendo/templates';
import { CompatibilityService } from '@common/services/compatibilityservice';
import { GridColumn, NavGridVisibility, Observable } from '@common/nav';
import { RwfInvoiceData, IncoreFilter, Event_ApplyFilter, InvoiceDataListType } from '@common/rwf/rwfinvoicedata';
import { InvoiceEditItem, EditWorkflowInstance, ExternalFilters } from '../KWFUtils';
import { IsKameral, RwfBootstrap, IFDRW_Workflow_Running_Instances } from '@common/rwf';
import { KWFAppActions } from '../KWFAppActions';

import '../editmarkup/editmarkup'; // Force import !
import { GlobalMarkupService } from '../editmarkup/editmarkup';

const dataBound = "dataBound";
const AttachColumns = "AttachColumns"
type InfUserSettingsAccess = _InfUserSettingsAccess & { _currentFilterName?: string };
/** Display a Invoice data Grid for my Invoices (Incore Data), 'filter' can be used to apply an initial filter   */
export const RwfInvoicesGrid = ["RwfBootstrap", "KWFAppActions", "GlobalMarkup", "CompatibilityService", "$location", function KWFInvoiceDataGrid(
  RwfBootstrap: RwfBootstrap,
  KWFAppActions: KWFAppActions,
  GlobalMarkup: GlobalMarkupService,
  $c: CompatibilityService,
  $location: angular.ILocationService): ng.IDirective {
  return {
    restrict: "AE",
    scope: {
      kwflistdata: "=",
      context: "=", // Actions 'clearfilter', 'resetfilter', ...,  Info "CurrentCount" , "HasFilter"
      grid: "=" // Out refernce to Created Grid
      // kwfsettings: as attribute
      // "filter" : as attribute]
    },
    link: (scope: ng.IScope & { kwflistdata: RwfInvoiceData }, instanceElement: ng.IAugmentedJQuery, instanceAttributes: ng.IAttributes) => {
      let listData = scope.kwflistdata,
        InvoiceData = listData && listData.InvoiceData;
      if (!InvoiceData)
        return;

      const invoiceGridHandler = new RwfInvoiveGridHandler(listData, scope, instanceElement, KWFAppActions, instanceAttributes.kwfsettings);

      scope.$on("$destroy", () => invoiceGridHandler.trigger("destroy"));

      const infoToResolve = {
        RwfSettings: RwfBootstrap.Resolve.then(r => r.RwfSettings),
        WfSetup: RwfBootstrap.Resolve.then(r => r.RwfSetup),
        InvoiceData: $c.resolve("Rwf")("RwfInvoiceData").Resolve,
        DataSource: invoiceGridHandler.GetOrCreateDataSource(),
        Options: invoiceGridHandler.GetInvoiceGridOptions(),
        UserSettings: invoiceGridHandler.GetUserSettings(),
      };
      UISafe($c.all(infoToResolve).then(resolvedInfo => {
        const options = resolvedInfo.Options;
        const dataSource = resolvedInfo.DataSource;
        const initialUserSettings = resolvedInfo.UserSettings;
        initialUserSettings.Add("togglesearch", () => { return { Checked: togglesearch.Checked, Token: initialUserSettings._currentFilterName }; }, s => { togglesearch.Apply(s.Checked); });
        initialUserSettings.Add("Grid", GetGridOptionSettings(options, () => invoiceGridHandler.CreatedGrid));

        // setup external available context to be bound to UI
        // (Actions, Info )
        const extContext = scope["context"] = {
          EditGlobalMarkups: GlobalMarkup.EditAction,
          Data: listData,
          CurrentCount: 0,
          FilterActive: false,
          FilterInfo: "",
          resetgrid: invoiceGridHandler.ActResetGrid
        }; // FilterInfo : '(gefiltert 2 von 4)'

        // Adjust Column, UserSettings ...
        function reApplyUserSettings(fromNewSettings: boolean) {
          const us = invoiceGridHandler.GetUserSettings();
          var delayedApplyUserSettings = $c.when($().wait(25).then(() => {
            if (fromNewSettings) {
              us.Load();
            } else {
              us.ReApply();
            }
          }));
          instanceElement.kendoNavBusyIndicator(delayedApplyUserSettings);
          return delayedApplyUserSettings;

        }
        function applyFilter(filter: IncoreFilter) {
                    dataSource.filter(filter?.Filters || { });
          const isCustomFWFFilter = (listData.ListType == "FWF" || listData.ListType == "FWFAll") && filter?.CustomData;
          invoiceGridHandler.ResetDynamicCols(isCustomFWFFilter);
          if (isCustomFWFFilter) {
            instanceElement.kendoNavBusyIndicator(InvoiceData.FWFData.GetFWFAdditionalColumns(filter.ID).then((cols) => {
              invoiceGridHandler.NotifyColumns(cols);
              InvoiceData.PrepareInvoiceData(listData.Items);
              var tearDown = invoiceGridHandler.CreatedGrid?.addDynamicColumns(3, cols) || fn.noop;
              invoiceGridHandler.RegisterResetDynamicCols(withNewOnes => {
                tearDown();
                if (!withNewOnes) {
                  reApplyUserSettings(true);
                }
              });
              return reApplyUserSettings(true);
            }, err => {
              console.error(fn.resolveToError(err));
              throw err;
            }));
          } else {
                      if(refreshExternalContext) {
              refreshExternalContext();
            }
          }
        }
        scope.$on("$destroy",
          kutils.Bind(listData,
            (e: { Filter: IncoreFilter }) => applyFilter(e?.Filter), Event_ApplyFilter));
        if (listData.SelectedFilter?.CustomData) {
          applyFilter(listData.SelectedFilter);
        }
        // SetUp "Clear Filter" Action
        var clearFilter = extContext["clearfilter"] = <IInfOperation>{
          Enabled: true,
          Hidden: "Enabled",
          Execute: () => {
            listData.ApplyFilter(undefined); //Imp. triggers Event_ApplyFilter (see above)
            // Not nice : Notify Parent Scope
            scope.$emit("clearfilter", listData);
          }
        };
        interface DataSourceFilter {
          field: string;
          operator: string;
          value: string;
        }

        const refreshExternalContext = () => {
          const isKameral = IsKameral($c.resolve("Rwf")("RwfBootstrap").EnsureResolved().RwfSetup);
          let DocTypeReservation = isKameral ? "Mittelreservierung" : "Einkaufsbestellung";
          var documentTypeFilters = { logic: "and", filters: [] };
          if (dataSource?.filter() !== undefined)
            documentTypeFilters = JSON.parse(JSON.stringify(dataSource?.filter()));

          if (documentTypeFilters !== null && documentTypeFilters !== undefined) {
            var urlparams = $location.search();
            var initFilter = urlparams['filter'] || "";
            if (initFilter !== null && initFilter !== undefined && initFilter.trim() !== '') {
              if (initFilter === 'Reservation') {
                // Check if `documentTypeFilters` already contains an `or` filter group with specified `DocumentType` filters
                const hasOrGroupWithDocumentTypes = documentTypeFilters.filters.some(
                  (f: any) =>
                    f.logic === "or" &&
                    f.filters &&
                    f.filters.some(
                      (subFilter: DataSourceFilter) =>
                        (subFilter.field === "DocumentType" && subFilter.operator === "eq" && subFilter.value === DocTypeReservation) ||
                        (subFilter.field === "DocumentType" && subFilter.operator === "eq" && subFilter.value === "Einkaufsbestellung (Änderung)")
                    )
                );

                if (!hasOrGroupWithDocumentTypes) {
                  // Create the `or` filter group with the specified `DocumentType` values
                  const orFilterGroup = {
                    logic: "or",
                    filters: [
                      { field: "DocumentType", operator: "eq", value: DocTypeReservation },
                      { field: "DocumentType", operator: "eq", value: "Einkaufsbestellung (Änderung)" }
                    ]
                  };

                  // Preserve existing filters and add the new `or` group
                  documentTypeFilters.filters.push(orFilterGroup);
                }
              }
              else {
                if (!documentTypeFilters.filters.some((f: DataSourceFilter) => f.field === "DocumentType" && f.operator === "neq" && f.value === DocTypeReservation)) {
                  documentTypeFilters.filters.push({ field: "DocumentType", operator: "startswith", value: "" });
                  documentTypeFilters.filters.push({ field: "DocumentType", operator: "neq", value: DocTypeReservation });
                  documentTypeFilters.filters.push({ field: "DocumentType", operator: "neq", value: "Einkaufsbestellung (Änderung)" });
                }
              }
            }
          }
          if (JSON.stringify(dataSource?.filter()) !== JSON.stringify(documentTypeFilters)) {
            dataSource.filter(documentTypeFilters);
          }

          const filters = dataSource?.filter();

          const currCount = extContext.CurrentCount = dataSource?.total();
          const filterActive = extContext.FilterActive = clearFilter.Enabled = !!(filters && filters.filters && filters.filters.length > 0);
          const filterDetail = (filterActive && listData && currCount != listData.Items.length && " " + currCount + " von " + listData.Items.length) || "";
          const filterInfo = listData.SelectedFilter?.CustomData ? listData.SelectedFilter.Title + (filterDetail ? " -" + filterDetail : "") : "gefiltert";
          extContext.FilterInfo = (filterActive && "(" + filterInfo + ")") || "";
          $c.tick(); // as triggered outside of angular context
        };

        // SetUp "Toggle Search Row" Action
        let togglesearch = extContext["togglesearch"] = {
          Checked: false,
          Execute: () => {
            togglesearch.Apply(!togglesearch.Checked);

            reApplyUserSettings(false);
          },

          Apply(val: boolean) {
            if (togglesearch.Checked = val) {
              options.filterable = {
                mode: "row",
              };
            } else {
              delete options.filterable;
            }

            const kgrid = invoiceGridHandler.CreatedGrid;
            if (kgrid) {
              kgrid.options.filterable = $.extend({}, options.filterable);
            }
          }
        };

        // Apply External Filter if set
        var filterItem = fn.FindFirst(listData.Filters, "Selected", true),
          filter = filterItem && filterItem.Filters;

        //  Hack : No Restore User Filter on ext filter set
        const search = $c.resolve("Routing").Search();
        const explicitFilter = ExternalFilters.Resolve(search);

        if (explicitFilter.filters.length > 0) {
          explicitFilter.logic = 'and'
          filter = explicitFilter;
          var globalExtFilter = true;
        } else {
          globalExtFilter = search && search['filter'];
        }

        options.noRestoreFilter = !!globalExtFilter || (!!filter && !!dataSource.filter());
                dataSource.filter(filter || { });

        const afterLoadSettings = (userSettings: InfUserSettingsAccess) => {
          try {
            /** debounced store current settings (to be fired on relevant changes */
            var debounceStore = fn.debounce(() => {
              // save only with living grid instance --> settings get spoiled otherwise
              // (and save gets triggered on grid destroy anyways)
              const kgrid = invoiceGridHandler.CreatedGrid;
              if (kgrid && kgrid.element) {
                userSettings.Save();
              }
            }, 1000);
            refreshExternalContext();
          } finally {
            if (debounceStore) {
              // Auto Save Changed Grid Settings
              invoiceGridHandler.CreateGrid().then(kgrid => {
                INavGridImp.ColumnChangeEvents.forEach(ev => kgrid.bind(ev, debounceStore));
                ["change"].forEach(ev => {
                  dataSource.bind(ev, debounceStore);
                  scope.$on("$destroy", () => dataSource.unbind(ev, debounceStore));
                });
              });
            }
          }
        };

        if (initialUserSettings) {
          initialUserSettings.Load().then(() => afterLoadSettings(initialUserSettings), () => afterLoadSettings(initialUserSettings));
        } else {
          afterLoadSettings(undefined);
        }
        dataSource.bind("change", refreshExternalContext);
        // Cleanup Created grid, datasource (order is important for settings persistence)
        scope.$on("$destroy", () => {
          const kgrid = invoiceGridHandler.CreatedGrid;
          if (kgrid && kgrid.element) {
            kgrid.destroy();
          }

          dataSource.unbind("change", refreshExternalContext);
          dataSource.data([]); // Reset Data Necessary for GC (release Registered Events)
        });
      }));
    }
  };
}];

class RwfInvoiveGridHandler extends Observable {

  constructor(private readonly listData: RwfInvoiceData, private readonly $scope: ng.IScope,
    private readonly instanceElement: JQuery,
    private readonly KWFAppActions: KWFAppActions,
    private readonly kwfsettings: string) {
    super();
    const $c = this.$c = listData.InvoiceData.$c;
    // Create Toolbar scope as child of this directive's parent scope --> allows Usage of external Functionality
    this.scopeToolBar = $scope.$parent.$new();
    this.$injector = angular.element(instanceElement).injector();

    this.ActResetGrid = {
      Enabled: false,
      Hidden: "Enabled",
      Execute: () => $c.resolve("DialogService").ShowConfirm({
        title: "RWF3",
        message: "Soll diese Ansicht bzgl. Spalten, Gruppierung und Sortierung auf den Standard zurückgesetzt werden?",
      }).then(answer => answer && this.resolvedUserSettings.Reset())
    };
  }
  private readonly $c: CompatibilityService;
  private readonly scopeToolBar: ng.IScope;
  private readonly $injector: ng.auto.IInjectorService;

  RegisterResetDynamicCols(action: (withNewOnes: boolean) => any) {
    this._resetDynamicCols.push(fn.once((x) => action(x)));
  }
  private readonly _resetDynamicCols = new Array<(bool) => any>();

  public ResetDynamicCols(withNewOnes: boolean) {
    const _resetDynamicCols = this._resetDynamicCols;
    try {
      _resetDynamicCols.forEach(item => item(withNewOnes));
    } finally {
      _resetDynamicCols.length = 0;
    }
  }

  private PrepareFWFColumnsBeforeColumnsPopup(grid: INavGridImp) {
    const selectedFilter = this.listData?.SelectedFilter;
    const listType = this.listData?.ListType;
    const fwfTypeId = ((listType == "FWF" || listType == "FWFAll") && selectedFilter?.CustomData && selectedFilter.ID) || undefined;
    if (!fwfTypeId) {
      return;
    }

    return this.listData.InvoiceData.FWFData.GetFWFAdditionalColumns(fwfTypeId).then(cols => {
      const allCols = grid.getAllColumns() || [];
      const allColMap = fn.ToDictionary(allCols.filter(item => !!item.field), item => item.field);
      const missingCols = cols.filter(item => !!item.field && !allColMap[item.field]);
      if (missingCols.length > 0) {
        this.NotifyColumns(missingCols);
        const tearDown = grid.addDynamicColumns(3, missingCols);
        this.RegisterResetDynamicCols(() => tearDown());
      }
    });
  }

  GetOrCreateDataSource() {
    const listData = this.listData;
    const $c = this.$c;
    return this.resolveDataSource || (this.resolveDataSource = this.$c.all({
      IsKameral: $c.resolve("Rwf")("RwfBootstrap").Resolve.then(r => IsKameral(r.RwfSetup))

    }).then(resolvedInfo => {
      const dataSource = this.dataSource = kutils.GetGridDataSource(listData.Items, listData.Client.MetaData.Model);
      const InvoiceData = listData.InvoiceData;
      const listType = listData.ListType;
            const initGrouping = listType == "FWF" || listType == "FWFAll"  ? [{ field: InvoiceData.FieldMap.CurrStep }] : (resolvedInfo.IsKameral ? [{ field: InvoiceData.FieldMap.CurrStep }] : [{ field: InvoiceData.FieldMap.Accounting }, { field: InvoiceData.FieldMap.CurrStep }]);
      dataSource.group(initGrouping);
      return dataSource;
    }));
  }
  private resolveDataSource: PromiseLike<kendo.data.DataSource>;
  private dataSource: kendo.data.DataSource;

  /** Resolve Initial Grid Options */
  GetInvoiceGridOptions(): PromiseLike<NavGridOptions> {
    const listData = this.listData;
    const listType = this.listData?.ListType;
    const $c = listData.InvoiceData.$c as CompatibilityService;
    var options: NavGridOptions;

    return this._initialGridOptions || (this._initialGridOptions = ($c.all({
      Columns: this.GetInvoiceColumns(),
      InvoiceData: listData.InvoiceData.Resolve,
      DataSource: this.GetOrCreateDataSource()
    }).then(resolvedInfo => {
      options = <NavGridOptions>{
        columns: resolvedInfo.Columns, //displayColumns -> visibleDisplayColumns: performance boost: ~200%
        selectable: true, //"multiple": no text selection
        resizable: true, // performance loss: ~18%
        reorderable: true, // performance loss: ~0%
        dataSource: resolvedInfo.DataSource,
        sortable: {}, // performance loss: ~5%
        groupable: { messages: { empty: "Ziehen Sie eine Spaltenüberschrift hierher, um Belege nach dieser Spalte zu gruppieren!" } }, // performance loss: ~9%
        pageable: {
          pageSize: kconstants.DefaultPaging,
          pageSizes: kconstants.DefaultPagings,
          messages: {
            display: "Anzeigen der Belege {0} - {1} von {2}",
            empty: "Keine Belege zum Anzeigen",
            itemsPerPage: "Belege pro Seite"
          }
        },
        columnMenu: { filterable: false }, // performance loss: ~50%
        excel: {
          allPages: true
        },
        navigatable: true, // Use arrow keys to navigate on grid (functionality added)

        // Custom added options
        groupingDescription: "Belege gruppiert nach:",
        storeGroupingState: { key: "EntryNo" },
        beforeOpenColumnSelection: (grid) => this.PrepareFWFColumnsBeforeColumnsPopup(grid),
        dblClick: (e) => {
          var evt = e.event;
          var currItem = kutils.GetRowItem(evt);
          var isEditable = (listType != "InvolvedInvoices") && listData.IsItemEditable(<any>currItem, true, listType == "MyInvoices");
          if (isEditable) {
            // evt.cancelBubble = true;
            // invoiceData.NavigateEditItem(evt);
            EditWorkflowInstance($c, evt); // byus ...
          }
        }
      };

      switch (listType) {
        case "MyInvoices":
          this.scopeToolBar["Actions"] = this.KWFAppActions.MyInvoices;
          options.customMultiSelect = true;
          options.toolbar = [{ template: GetCustomKendoTemplate("DataGridMyInvoiceToolbarTemplate") }];
          break;
        case "AllInvoices":
          options.toolbar = [{ template: GetCustomKendoTemplate("DataGridAllInvoiceToolbarTemplate") }];
          break;
        case "InvolvedInvoices":
          options.toolbar = [{ template: GetCustomKendoTemplate("DataGridInvolvedInvoiceToolbarTemplate") }];
          break;

        case "FWF":
          this.scopeToolBar["Actions"] = this.KWFAppActions.FWF;
          options.customMultiSelect = true;
          options.toolbar = [{ template: GetCustomKendoTemplate("DataGridFWFItemsToolbarTemplate") }];
          break;

        case "FWFAll":
          options.toolbar = [{ template: GetCustomKendoTemplate("DataGridFWAllItemsToolbarTemplate") }];
          break;
        default:
          fn.never(listType, "Unexpected");
      }

      return options;
    })));
  }
  private _initialGridOptions: PromiseLike<NavGridOptions>;

  private readonly onCreateGrid = new Array<() => any>();

  public get CreatedGrid() { return this.createdGrid; }
  private createdGrid: INavGrid;

  CreateGrid() {
    const $c = this.$c;
    const onCreateGrid = this.onCreateGrid;
    const listType = this.listData.ListType;
    const instanceElement = this.instanceElement;
    const scopeToolBar = this.scopeToolBar;
    const rwf = $c.resolve("Rwf");
    const RwfAppSettings = rwf("RwfAppSettings");
        const rwfBootstrap =  $c.resolve("Rwf")("RwfBootstrap");
    return $c.all({
      GridOptions: this.GetInvoiceGridOptions(),
      RwfApplicationSettings: RwfAppSettings.Get(),
      RwfBootstrap: rwfBootstrap.Resolve,
      UserSettings: this.GetUserSettings()
    }).then(resolvedInfo => {
      try {
        onCreateGrid.forEach(item => item());
      } finally {
        onCreateGrid.length = 0;
      }
      var createdGrid = this.createdGrid = this.$scope["grid"] = instanceElement.kendoNavGrid(resolvedInfo.GridOptions).data("kendoNavGrid");

      const tearDowndataBound = Bind(createdGrid, (e) => this.trigger(dataBound, e), dataBound);
      createdGrid.one("destroy", tearDowndataBound);
      this.one("destroy", tearDowndataBound);

      // dispatch grid events to this ..
      ["ToggleCustomSelection", "CustomSelectionChanged"].forEach(event => {
        this.one("destroy", Bind(createdGrid, (e) => this.trigger(event, e), event));
      });

      // store Settings on grid Destroy
      createdGrid.bind(kconstants.NavDestroy, () => resolvedInfo.UserSettings?.Save());
      const KWFAppActions = this.KWFAppActions;
      if ((listType == "MyInvoices" || listType == "FWF") && KWFAppActions && KWFAppActions[listType]) {
        this.$scope.$on("$destroy", KWFAppActions[listType].SetInvoiceGrid(createdGrid));
      }

      // SetUp Grid Customization Functionality
      var unbind = fn.noop;
      function refreshGridCustomization(explicit?: IGridCustomization) {
        unbind();
        // Attach Configured Conditional Row/Cell Markup for MyInvoices/AllInvoices
        var globalCustomization: IGridCustomization = explicit?.RowCustomizations ? explicit : resolvedInfo.RwfApplicationSettings,
          userName = resolvedInfo.RwfBootstrap?.RwfUser.ID;

        unbind = BindGridCustomizations(createdGrid, globalCustomization, { CurrentUser: userName });
      }
      refreshGridCustomization();
      // ReApply changed Customization on current grid
      createdGrid.bind(kconstants.NavDestroy,
                    this.$scope.$root.$on("$KWF.MarkupsChanged", (s,e) => refreshGridCustomization(e)));

      // This way we can Use Angular Functionality in Toolbar (the created Grid is NOT ng-aware!)
      if (scopeToolBar) {
        let compileToolBar = () => this.$injector.get("$compile")($(".k-grid-toolbar", instanceElement))(scopeToolBar);
        // We must reCompile when reCreated!
        createdGrid.bind(INavGrid.GridContentCreated, compileToolBar);
        compileToolBar();
      }
      onCreateGrid.push(() => createdGrid.destroy());
      return createdGrid;
    });
  };

  /** Get Columns for Display for Invoice Data */
  GetInvoiceColumns(): PromiseLike<GridColumn[]> {
    let invoiceData = this.listData,
      $c = this.$c,
      invoiceDataService = invoiceData.InvoiceData,
      listType = invoiceData.ListType;
    // As Editable Column/ or Filters for AllInvoices depends on MyInvoices Data, ensure MyInvoices is Resolved in this before retrieving Columns
    if ((<InvoiceDataListType[]>["AllInvoices", "FWF"]).indexOf(invoiceData.ListType) >= 0) {
      const MyInvoices = invoiceDataService.MyInvoices;
      var ensureData = $c.when(MyInvoices.Items?.length ? undefined : MyInvoices.GetData()).then(fn.nullOp, fn.nullOp);
    }

    return $c.when(ensureData).then(() => {
      const ListType = invoiceData.ListType;
      var result = invoiceData.Fields.filter(item => !item.Invisible && item.GridVisibility != NavGridVisibility.ForcedRemove)
        .filter(ListType == "FWF" || listType == "FWFAll" ? item => fwfCols.indexOf(<any>item.Name) >= 0 : item => fwfOnlyCols.indexOf(<any>item.Name) < 0)
        .map(item => invoiceData.Client.MetaData.GetColumn(item));

      this.setupNotifyColumns(ListType == "MyInvoices" || ListType == "FWF");
      this.NotifyColumns(result);

      // Dependent MyInvoice Edit button
      var dependentEditColEdit = <GridColumn>{
        field: '',
        filterable: false,
        title: '',
        width: kconstants.KendoGrid_ActionIconColumnSize,
        template: (dataItem) => {
          var showEditIcon = invoiceData.IsItemEditable(dataItem);
          return showEditIcon ?
            "<span class='idms_Icon idms_Icon_Edit idms_HoverIcon' title='Beleg bearbeiten' onclick='KWF.EditWorkflowInstance(this, event)'></span>" : "";
        }
      };

      // Readonly button
      var readonlyCol = <GridColumn>{
        field: '',
        filterable: false,
        title: '',
        width: kconstants.KendoGrid_ActionLargerIconColumnSize,
        command: [{
          attr: { title: "Beleg lesend öffnen" },
          name: "openKWFRowItemReadonly", text: "", className: "idms_DataGridButton",
          click: (event) => _EditRowItem(event, true),
          template: "<a class='k-grid-openKWFRowItemReadonly'><span class='idms_Icon idms_Icon_LEye idms_HoverIcon' title='Beleg lesend öffnen'></span></a>"
        }],
      };

      /** Edit nav row item under mouse pointer */
      function _EditRowItem(this: void, evt: Event, readOnly = false) {
        var rowitem = GetRowItem(evt);

        if (!rowitem)
          return;
        evt.cancelBubble = true;

        fn.UISafe(InvoiceEditItem($c, rowitem, invoiceData.InvoiceData, readOnly).then(() => {
          var grid = GetGrid(evt);
          if (grid)
            grid.element.kendoNavBusyIndicator(true);
        }));
      }

      // Dependent edit button
      var dependentEditColOpen = <GridColumn>{
        field: '',
        filterable: false,
        title: '',
        width: kconstants.KendoGrid_ActionIconColumnSize,
        template: dataItem => {
          var showEditIcon = invoiceData.IsItemEditable(dataItem, true);
          return showEditIcon ?
            "<span class='idms_Icon idms_Icon_Edit idms_HoverIcon' title='Beleg bearbeiten' onclick='KWF.EditWorkflowInstance(this, event)'></span>" : "";
        }
      };

      // Preview button
      var previewCol = <GridColumn>{
        field: '',
        filterable: false,
        title: '',
        width: kconstants.KendoGrid_PreviewIconColumnSize,
        template: GetCustomKendoTemplate(PreviewTemplates[listType] || PreviewTemplates[""])
      };

      const actRetractItem = (event) => {
        const item = kutils.GetRowItem(event);
        const InvoiceData = invoiceData.InvoiceData;
        const NavClient = $c.resolve("NavClient");
        const DialogService = $c.resolve("DialogService");
        const result = InvoiceData.GetPageClient("MyInvoices").then(s => {
          return NavClient.ConstructItem(item.toJSON(), s, "").then(item => {
            return DialogService.ShowConfirm("Soll der Beleg zurückgeholt werden?").then(f => {
              return f && item.ExecuteMethod({ MethodName: "RetractWorkflow" }).then(() => {
                InvoiceData.RefreshInvoiceData(true);
                EditWorkflowInstance($c, item.Model);
              });
            });
          });
        }).then(fn.noop, err => {
          return DialogService.ShowError(fn.resolveToError(err));
        });
        const grid = kutils.GetGrid(event);
        if (grid) {
          grid.element.kendoNavBusyIndicator(result);
        }
      };

      // Add buttons regarding source
      switch (listType) {
        case "AllInvoices":
          result.unshift(dependentEditColOpen, readonlyCol, previewCol);
          break;
        case "MyInvoices":
        case "FWF":
        case "FWFAll":
          result.unshift(dependentEditColEdit, readonlyCol, previewCol);
          break;
        case "InvolvedInvoices":
          let retractCol: kendo.ui.GridColumn = {
            field: '',
            filterable: false,
            title: '',
            width: kconstants.KendoGrid_ActionLargerIconColumnSize,
            command: [{
              attr: { title: "Beleg lesend öffnen" },
              name: "retractWfInstanceItem", text: "", className: "idms_DataGridButton",
              template: "<a class='k-grid-retractWfInstanceItem'><span class='idms_Icon idms_Icon_Retract idms_HoverIcon' title='Beleg zurückholen'></span></a>",
              click: actRetractItem,
            }],
          };
          result.unshift(previewCol, retractCol);
          break;
        default:
          fn.never(listType, "Unexpected ListType");
        // ?? Unknown list Type !!
      }
      return result;
    });
  }

  GetUserSettings() {
    const $c = this.$c;
    const isKameral = IsKameral($c.resolve("Rwf")("RwfBootstrap").EnsureResolved().RwfSetup);
    const postFix = isKameral ? "KAM" : "";
    /** append 'SP' Token for Sharepoint scenario to allow 'discerning' in RWF2 -> RWF3 migration scenario */
    let settingsToken = this.kwfsettings && (this.kwfsettings + postFix);

    if (this.listData.SelectedFilter?.CustomData) {
      settingsToken += "_" + this.listData.SelectedFilter.ID;
    }

    let result = this.resolvedUserSettings;
    if (result) {
      if (result._currentFilterName != settingsToken) {
        result._currentFilterName = settingsToken;
        result.RefreshPersistKey(["KWF", "UserDesk", settingsToken], false);
      }
    }
    else {
      result = this.resolvedUserSettings = this.resolvedUserSettings = (settingsToken && $c.resolve("NavSettings").CreateUserSettings(["KWF", "UserDesk", settingsToken]));
      result._currentFilterName = settingsToken;
      const actChange = () => {
        this.ActResetGrid.Enabled = result.HasChanges && (result.OperationCount <= 0);
      };
      const subscription = result.subscribe(actChange);
      this.$scope.$on("$destroy", () => subscription.unsubscribe());
    }
    return this.resolvedUserSettings;

    // return this.userSettings || (this.userSettings = $c.all({
    // }).then(() => {
    //     /** User Settings access for Grid Data */
    //     var result = this.resolvedUserSettings = (settingsToken && $c.resolve("NavSettings").CreateUserSettings(["KWF", "UserDesk", settingsToken]));

    //     const actChange = () => {
    //         this.ActResetGrid.Enabled = result.HasChanges && (result.OperationCount <= 0);
    //     };
    //     const subscription = result.subscribe(actChange);
    //     this.$scope.$on("$destroy", () => subscription.unsubscribe());

    //     return result;
    // }));
  }
  //private userSettings: PromiseLike<InfUserSettingsAccess>;
  private resolvedUserSettings: InfUserSettingsAccess;

  public readonly ActResetGrid: IInfOperation;

  public get CurrGroupData() {
    if (!this.currGroupData && this.dataSource && this.listData) {
      const ds = this.dataSource;
      this.one(dataBound, () => this.currGroupData = undefined);
      this.currGroupData = new kendo.data.Query(fn.ToArray(this.listData.Items)).filter(ds.filter()).group(ds.group());
    }
    return this.currGroupData;
  }
  private currGroupData: kendo.data.Query;

  /*** Neeeded due to dynamic/late Column Creation (FWF/Dynamic Data) */
  public NotifyColumns(columns: GridColumn[]) {
        this.trigger(AttachColumns,{  Columns : columns });
  }
  // attach Custom Count info logic + custom grouped multi select logic to group headers
  private setupNotifyColumns(customColSelect: boolean) {
    type TGroupState = { Value: any, Id: string, Items: any[] };
    let currFieldGroupState: Record<string, TGroupState> = {};
    const currIdGroupState: Record<string, TGroupState> = {};

    this.bind(dataBound, (s, e) => currFieldGroupState = {});

    if (customColSelect) {
      this.bind("ToggleCustomSelection", (e) => {
        var row = $(e.row);
        var rid: string;
        var cb = row.find(".navRowCheckbox")[0] as HTMLInputElement;
        if (this.createdGrid && row.hasClass("k-grouping-row") && (rid = $(cb).attr("data-rid"))) {
          var t = currIdGroupState[rid]
          if (t) {
            const leaveItems = FlattenQuery(t.Items);
            this.createdGrid.GetSelectedItems().SetSelected(cb.checked, ...leaveItems);
            e.preventDefault();
          }
        }
      });

      const OnCustomSelectionChanged = () => {
        var items = this.createdGrid.content.find(".k-grouping-row input.navRowCheckbox[data-rid]");
        items.each((idx, elem: HTMLInputElement) => {
          var tState = currIdGroupState[elem.getAttribute("data-rid")];
          var indeterminate = false;
          var disabled = false;
          var checked = false;
          if (tState) {
            const selItems = this.createdGrid.GetSelectedItems();
            var selState = tState.Items.map(item => selItems.GetSelected(item));
            var checkCount = selState.reduce((a, b) => a + (b ? 1 : 0), 0);
            if (checkCount === tState.Items.length) {
              checked = true;
            } else if (checkCount == 0) {
              // default ...
            } else {
              indeterminate = true;
            }
          } else {
            disabled = true;
          }
          elem.indeterminate = indeterminate;
          elem.checked = checked;

          if (disabled) {
            elem.disabled = true;
          } else if (elem.disabled) {
            delete elem.disabled;
          }
        });
      };
      this.bind(["CustomSelectionChanged", dataBound], OnCustomSelectionChanged);
    }

        const attachColumn = (item: GridColumn & { __CustomInvoiceHandling : true}) => {
            if(!item || item.__CustomInvoiceHandling === true) {
        return;
      }
      item.__CustomInvoiceHandling = true;
      var orig = typeof item.groupHeaderTemplate == "function" ? item.groupHeaderTemplate : item.groupHeaderTemplate ? kutils.template(item.groupHeaderTemplate) :
        (data => {
          var idx: any;
          var value = data.value;
          var values = item.values;
          if (Array.isArray(values) && (idx = fn.FindFirst(values, item => item.value == value))) {
            value = idx?.text || value;
          } else if (item.format) {
            try {
              value = kendo.format(item.format, value);
                    } catch(err) {
              // fallback to rawvalue if format fails
            }
          }
          return item.title + ': ' + value;
        });
      item.groupHeaderTemplate = (data: { value: any, field: string, items: any[] }) => {
        const currState = currFieldGroupState[data.field] = { Value: data.value, Id: fn.id(), Items: [] };
        currIdGroupState[currState.Id] = currState;
        // defer cleanup after "after next"
        this.one(dataBound, () => {
          this.one(dataBound, () => delete currIdGroupState[currState.Id]);
        });
        const currGroupData = this.CurrGroupData;
        var fields = (this.dataSource.group() as any[]).map(item => item.field);
        var idx = fields.indexOf(data.field);
        var pathValid = true;
        var rData: any[] = currGroupData.data;
        for (var i = 0; i <= idx; i++) {
          const currField = fields[i];
          pathValid = pathValid && currField in currFieldGroupState;
          if (pathValid) {
            // TODO Caution: Adjusted Gruping (datetime to date, ...)
            rData = rData.filter(item => item.value == currFieldGroupState[currField].Value);
            if (rData.length == 1 && rData[0].items) {
              rData = rData[0].items;
            }
          }
        }
        currState.Items = rData;
        var count = pathValid && rData && ReduceQueryLeafs(rData, (curr, next) => curr += next.length, 0);
        if (kutils.InExcelSaveOp()) {
          // no explict html Rendering in Excel saveOp
          return orig(data) + (count > 0 ? ' (' + count + ')' : '');
        } else {
          var selTemplate = pathValid && customColSelect && idx == (fields.length - 1) && `<input type="checkbox" kendo-check-box data-rid="` + currState.Id + `" class="navRowCheckbox" onchange="infoma.kwidgets.INavGridImp.ToggleCustomSelection(event);">`;
          return (selTemplate ? selTemplate : "") + orig(data) + (count > 0 ? (' <span data-field="' + data.field + '" style="font-size: small;font-style: italic;">(' + count + ')</span>') : '');
        }
      };
    };

    this.bind(AttachColumns, (e) => {
      var cols = e.Columns as GridColumn[];
            if(cols?.length) {
        cols.forEach(attachColumn);
      }
    });
  }
}

function FlattenQuery(item: kendo.data.Query | any[]) {
  let result = [];
  ReduceQueryLeafs(item, (curr, items) => result.push.apply(result, items), <void>undefined);
  return result;
}

function ReduceQueryLeafs<T>(item: kendo.data.Query | any[], action: (curr: T, items: any[]) => T, root: T) {
  if (item instanceof kendo.data.Query) {
    item = item.data;
  }
  if (item && item.length) {
    iterate(item);
    return root;
  }
  function iterate(items: any[]) {
    const first = items[0];
    if (!("hasSubgroups" in first)) {
      root = action(root, items);
    } else if (first.hasSubgroups) {
      items.forEach(item => iterate(item.items));
    } else {
      items.forEach(item => root = action(root, item.items));
    }
  }
}

// template: GetCustomKendoTemplate(listType == "InvolvedInvoices" ? "DataGridNavPreviewButtonTemplateInvolved" : ("DataGridNavPreviewButtonTemplate"))
const PreviewTemplates: Partial<Record<InvoiceDataListType | "", TEMPLATE_ID>> = {
  InvolvedInvoices: "DataGridNavPreviewButtonTemplateInvolved",
  //FWF: "DataGridNavPreviewButtonTemplateFWF",
  "": "DataGridNavPreviewButtonTemplate"
};
let fwfCols: (keyof IFDRW_Workflow_Running_Instances)[] = [
  "ActionType",
  "CheckedOutBy",
  "CheckedOutSince",
  "CurrentBreakout",
  "CurrentWorkflowPart",
  "CurrentWorkflowPart_Name",
  "CurrentWorkflowStep",
  "CurrentWorkflowStep_Name",
  "CurrentWorkflowUser",
  "CustProp1", "CustProp2", "CustProp3", "CustProp4", "CustProp5",
  "Due_Date",
  "EntryNo",
  "ForwardingComment",
  "ID",
  "Involved",
  "InvoiceLegder",
  "LastChanged", "LastChangedBy",
  "LastStatusChange",
  "LastStatusInfo",
  "LastStepCode",
  "LastStepName",
  "MainDocExists",
  "MyDocument",
  "ProcessRouting",
  "Remark",
  "RoutingError",
  "Remark",
  "SupDocsCount",
  "WorkflowType",
  "WorkflowTypeDescription",
  "View",
];

let fwfOnlyCols: (keyof IFDRW_Workflow_Running_Instances)[] = [
  "WorkflowType",
  "WorkflowTypeDescription"
];
